import React from "react";
import "./index.scss";

export interface ProgressBarProps {
  value: number; // Percentage (0-100)
  score?: number; // Current score
  total?: number; // Total score
  showLabel?: boolean; // Show percentage label
  size?: "small" | "medium" | "large";
  className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  score,
  total,
  showLabel = true,
  size = "medium",
  className = "",
}) => {
  // Clamp value between 0 and 100
  const percentage = Math.min(Math.max(value, 0), 100);

  // Determine color based on percentage
  // Based on screenshot: green for high (85%), orange for medium (25%), red for very low (15%)
  const getColorClass = () => {
    if (percentage >= 70) return "success"; // Green
    if (percentage >= 20) return "warning"; // Orange
    return "error"; // Red
  };

  const colorClass = getColorClass();

  return (
    <div className={`progress-bar-container ${size} ${className}`}>
      <div className="progress-bar-wrapper">
        <div
          className={`progress-bar-fill ${colorClass}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showLabel && (
        <div className="progress-bar-labels">
          {score !== undefined && total !== undefined && (
            <span className="progress-bar-score">
              ({score}/{total})
            </span>
          )}
          <span className={`progress-bar-percentage ${colorClass}`}>
            %{percentage}
          </span>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
